<template>
  <div class="ProjectEdit__part">
    <violet-bar>Axes du projet</violet-bar>
    <help-message>
      <h3 slot="title">Axes du projet</h3>
      <p>
        Vous pouvez ici ajouter des <strong>axes thématiques</strong> au
        projet.<br />De base, l'axe obligatoire nommé
        <strong>générique</strong> est présent.<br />Vous pouvez ajouter des
        thèmes ou choisir parmi les existants avec un champ de saisie
        prédictive.<br />Chaque image peut s'accompagner d'une légende.
      </p>
      <hr />
      <p>
        <strong>Si une image est un plan</strong>, vous devez en indiquer
        l'échelle
        <strong>vis à vis du fichier image envoyé, à 300dpi</strong>,<br />
        ainsi que l'orientation, exprimée
        <strong
          >en degrés positifs vis à vis du nord s'il était vers le haut.<br />
          Privilégiez 270° plutôt que -90°</strong
        >.
      </p>
    </help-message>
    <div class="Axes">
      <project-edit-axe-one
        v-for="(axe, index) in project.contents"
        :axe="axe"
        :index="index"
        :total="project.contents.length"
        :key="index"
        @delete="deleteBlock(index)"
        @down="moveAxeDown(index)"
        @up="moveAxeUp(index)"
        @update="updateAxe(index, $event)"
      />
    </div>
    <div class="buttons">
      <button class="button" style="margin-left: auto" @click="addBlock">
        Ajouter un axe
      </button>
    </div>
  </div>
</template>
<script>
import VioletBar from "../VioletBar";
import { cheapoClone } from "../../../util/func";
import { ContentBlock } from "../../../store/models/project";
import HelpMessage from "../../../components/Form/HelpMessage";
import ProjectEditAxeOne from "./ProjectEditAxeOne";

export default {
  name: "ProjectEdit-Axes",
  components: {
    ProjectEditAxeOne,
    HelpMessage,
    VioletBar
  },
  props: {
    item: {}
  },
  computed: {
    project: {
      get() {
        return this.item;
      },
      set(val) {
        this.$emit("update", val);
      }
    }
  },
  methods: {
    moveAxe(d, index) {
      const p = cheapoClone(this.project);
      p.contents.splice(index + d, 0, p.contents.splice(index, 1)[0]);
      this.project = p;
    },
    moveAxeUp(index) {
      this.moveAxe(-1, index);
    },
    moveAxeDown(index) {
      this.moveAxe(1, index);
    },
    updateAxe(index, val) {
      const p = cheapoClone(this.project);
      p.contents[index] = val;
      this.project = p;
    },
    addBlock() {
      const p = cheapoClone(this.project);
      p.contents.push(ContentBlock());
      this.project = p;
    },
    deleteBlock(index) {
      const p = cheapoClone(this.project);
      p.contents = p.contents.filter((a, i) => i !== index);
      this.project = p;
    }
  }
};
</script>

<style lang="scss">
.Axes,
.Axe {
  margin-bottom: 1em;

  &__pictures {
    margin-bottom: 1em;
  }

  &__picture {
    margin-bottom: 1em;
    position: relative;

    &__picture {
      flex: 0 0 300px;
      margin-right: 1em;
    }

    &__caption {
      flex: 1;
    }

    &__buttons {
      margin-right: 1em;
    }
  }
}

.Axe {
  position: relative;
  margin-left: auto;

  &__delete {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateX(-100%);
    display: flex;
    flex-direction: column;
  }
}
</style>
